<div class="container" *transloco="let t">
  <mat-icon class="mat-icon-init-style" svgIcon="attention"></mat-icon>
  <div class="content">
    {{ t('app.profile.cancelProfile.banner.content.part1') }}
    <br />
    {{
    'app.profile.cancelProfile.banner.content.part2'
    | transloco: { days: daysUntilDeletion }
    }}
    <br />
    {{ t('app.profile.cancelProfile.banner.content.part3.beforeLink') }}

    <xt-portal-button
      color="none"
      width="small"
      [text]="t('app.profile.cancelProfile.banner.content.part3.link.text')"
      (clickEvent)="onRevoke()"
      />

      {{ t('app.profile.cancelProfile.banner.content.part3.afterLink') }}
    </div>

    @if (loading) {
      <div class="spinner-container">
        <xt-ui-kit-spinner></xt-ui-kit-spinner>
      </div>
    }
  </div>
